import { render } from "./histo.vue?vue&type=template&id=01258fc2"
import script from "./histo.vue?vue&type=script&lang=ts"
export * from "./histo.vue?vue&type=script&lang=ts"

import "./histo.vue?vue&type=style&index=0&id=01258fc2&lang=css"
script.render = render

export default script